import Result from './Result.vue';
export default Result;



// WEBPACK FOOTER //
// ./src/components/anketaresult/index.ts